// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projectfields {
  margin-top: 30px;
  display: grid;
  grid-template-columns: 40% 40%;
  grid-column-gap: 70px;
  grid-row-gap: 20px;
  padding: 10px;
  justify-content: center;
  margin-bottom: 30px;
}
.main {
  height: 70vh;
  margin-top: 30px;
}

.layout {
  margin-top: 5px;
  padding-bottom: 5px;
  height: 92vh;
  overflow: scroll;
}

.formLayout {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
}
.formDetails {
  background-color: white !important;
  width: 95%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  /* width: 40%; */
  border-radius: 5px;
}
.projectbutton {
  background-color: #8b5ccc;
  border: none;
  color: white;
  padding: 5px 27px;
  text-align: center;
  font-size: 20px;
  margin-bottom: 30px;
  border-radius: 5px;
}

.projectbutton:hover {
  background-color: rgba(54, 3, 125, 0.919);
  color: white;
}

.back {
  padding: 5px 27px;
  text-align: center;
  font-size: 20px;
}
/* .projectbutton:hover {
  background-color: rgba(82, 82, 90, 0.919);
  color: white;
} */

.heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  padding: 10px 10px;
  /* color: #e1e0e0; */
  /* color: black; */
  /* background-color: rgb(3, 10, 29); */
  background-color: #d0d0d0;
  /* opacity: 0.95; */
  border-radius: 5px 5px 0px 0px;
}
.heading > h4 {
  margin-left: 10px;
  font-weight: 550;
  font-style: normal;
}
.projectheading {
  margin-top: 30px;
  margin-bottom: 30px;
  color: rgb(40, 121, 241);
}

.icon {
  margin-right: 10px;
  cursor: pointer;
}

/* .collapsing {
  transition-duration: 1.5s;
} */
/* 
.collapse:not(.show) {
  transition-duration: 4.1s;
} */

/* .collapse {
  transition-duration: 0.5s;
} */
`, "",{"version":3,"sources":["webpack://./src/components/createproject/project.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,UAAU;EACV,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;;GAEG","sourcesContent":[".projectfields {\n  margin-top: 30px;\n  display: grid;\n  grid-template-columns: 40% 40%;\n  grid-column-gap: 70px;\n  grid-row-gap: 20px;\n  padding: 10px;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n.main {\n  height: 70vh;\n  margin-top: 30px;\n}\n\n.layout {\n  margin-top: 5px;\n  padding-bottom: 5px;\n  height: 92vh;\n  overflow: scroll;\n}\n\n.formLayout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 15px;\n}\n.formDetails {\n  background-color: white !important;\n  width: 95%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  /* width: 40%; */\n  border-radius: 5px;\n}\n.projectbutton {\n  background-color: #8b5ccc;\n  border: none;\n  color: white;\n  padding: 5px 27px;\n  text-align: center;\n  font-size: 20px;\n  margin-bottom: 30px;\n  border-radius: 5px;\n}\n\n.projectbutton:hover {\n  background-color: rgba(54, 3, 125, 0.919);\n  color: white;\n}\n\n.back {\n  padding: 5px 27px;\n  text-align: center;\n  font-size: 20px;\n}\n/* .projectbutton:hover {\n  background-color: rgba(82, 82, 90, 0.919);\n  color: white;\n} */\n\n.heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 95%;\n  padding: 10px 10px;\n  /* color: #e1e0e0; */\n  /* color: black; */\n  /* background-color: rgb(3, 10, 29); */\n  background-color: #d0d0d0;\n  /* opacity: 0.95; */\n  border-radius: 5px 5px 0px 0px;\n}\n.heading > h4 {\n  margin-left: 10px;\n  font-weight: 550;\n  font-style: normal;\n}\n.projectheading {\n  margin-top: 30px;\n  margin-bottom: 30px;\n  color: rgb(40, 121, 241);\n}\n\n.icon {\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n/* .collapsing {\n  transition-duration: 1.5s;\n} */\n/* \n.collapse:not(.show) {\n  transition-duration: 4.1s;\n} */\n\n/* .collapse {\n  transition-duration: 0.5s;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
